<h2 id="contact">Contacteer onze helpdesk</h2>

@if (state === StatEnum.INITIAL || state === StatEnum.PROCESSING) {
  <ng-container *ngTemplateOutlet="initial; context: { uiState: uiState.initial }"></ng-container>
}

@if (state === StatEnum.SUCCESS) {
  <ng-container *ngTemplateOutlet="feedback; context: { uiState: uiState.success }"></ng-container>
}
@if (state === StatEnum.ERROR) {
  <ng-container *ngTemplateOutlet="feedback; context: { uiState: uiState.error }"></ng-container>
}

<ng-template #initial let-uiState="uiState">
  <div class="[ flex flex-wrap justify-center gap-m ]">
    <dcr-image src="assets/images/contact.png" class="illustration"></dcr-image>

    <form class="form [ flex flex-column flex-1 gap-m ]" [formGroup]="form" (ngSubmit)="submit()">
      <dcr-text-field label="Naam" formControlName="name"></dcr-text-field>
      <dcr-text-field label="School" formControlName="schoolName"></dcr-text-field>
      <dcr-text-field label="E-mailadres" type="email" formControlName="email"></dcr-text-field>
      <dcr-text-field label="Telefoonnummer" type="phone" formControlName="phone"></dcr-text-field>
      <dcr-select label="Onderwerp" formControlName="subject">
        @for (subject of subjects; track subject) {
          <dcr-select-option [value]="subject" [label]="subject"></dcr-select-option>
        }
      </dcr-select>
      <dcr-text-field label="Bericht" type="textarea" formControlName="message"></dcr-text-field>

      <dcr-filled-button
        type="submit"
        label="Versturen"
        [disabled]="!form.valid && state !== StatEnum.PROCESSING"
      ></dcr-filled-button>
    </form>
  </div>
</ng-template>

<ng-template #feedback let-uiState="uiState">
  <div>
    <div class="[ stack stack-space-m items-center ]">
      <campus-svg [svgImage]="uiState.img" class="[ w-full ]"></campus-svg>

      <h5>{{ uiState.header }}</h5>

      <div>
        @for (paragraph of uiState.description; track paragraph) {
          <p class="[ text-center ]" [innerHTML]="paragraph"></p>
        }
      </div>

      @if (state === StatEnum.SUCCESS) {
        <dcr-filled-button (click)="reset()" [label]="uiState.cta"></dcr-filled-button>
      }
      @if (state === StatEnum.ERROR) {
        <dcr-filled-button (click)="submit()" [label]="uiState.cta"></dcr-filled-button>
      }
    </div>
  </div>
</ng-template>
